// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1y3MX","errors":"Errors_errors__3vx5i"};